import styled from "styled-components"

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  margin: 0 0 1.5rem;
`
